export default __webpack_public_path__ + "app/images/theme-images/light/extend-btn/icon-20-arrow-right@2x.webp";